import axiosIns from "@/api/axios";

export const GET_ALL_DATA = (args) => {
  return axiosIns.get(`quesioner/question?${args}`);
};

export const ADD_DATA = (args) => {
  return axiosIns.post(`quesioner/question/create`, args);
};

export const SHOW_DATA = (id) => {
  return axiosIns.put(`quesioner/question/byid?id=${id}`);
};

export const UPDATE_DATA = (args) => {
  return axiosIns.put(`quesioner/${args.id}/update`, args);
};

export const DELETE_DATA = (id) => {
  return axiosIns.delete(`quesioner/question/delete?id=${id}`);
};
